import { render, staticRenderFns } from "./StreamPlayer.vue?vue&type=template&id=028aeb07&"
import script from "./StreamPlayer.vue?vue&type=script&lang=js&"
export * from "./StreamPlayer.vue?vue&type=script&lang=js&"
import style0 from "./StreamPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports